import { useForm } from "react-hook-form";
import FirstStep from "../../pages/DemandForm/CommonStep/FirstStep";
import { useCallback, useEffect, useState } from "react";
import ServiceFirstStep from "../../pages/DemandForm/Services/ServiceFirstStep";
import SubmitButton from "../forms/Buttons/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import { adminActions } from "../../actions/admin.actions";
import { getCertificationTypeStringValue } from "../../utils/enum";
import FirstStepAdmin from "../../pages/DemandForm/CommonStep/FirstStepAdmin";

export default function UpdateCertifications({ certificationsData }) {
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    reset,
    unregister,
  } = useForm();

  const dispatch = useDispatch();

  const [formData, setFormData] = useState(certificationsData);
  const [errorCount, setErrorCount] = useState(0);
  const [serviceOption, setServiceOption] = useState();
  const [serviceOptionType, setServiceOptionType] = useState();
  const onChangeFormType = (value) => {
    setServiceOptionType(value);
  };
  const onChangeServiceType = (value) => {
    setServiceOption(value);
  };

  const onSubmit = (data) => {
    console.log(`getValues: ${JSON.stringify(data)}`);
    //force the type to be boolean
    if (data["preTransactionCertification"]) {
      console.log(
        `yes data pre: ${JSON.stringify(data["preTransactionCertification"])}`
      );
      data["preTransactionCertification"] = Boolean(
        data["preTransactionCertification"]
      );
      console.log(
        `yes data pre update: ${JSON.stringify(
          data["preTransactionCertification"]
        )}`
      );
    }
    if (data["estimatedFirstTransDate"]) {
      data["estimatedFirstTransDate"] = new Date(
        data["estimatedFirstTransDate"]
      ).toISOString();
    }
    if (data["shippingDate"]) {
      data["shippingDate"] = new Date(data["shippingDate"]).toISOString();
    }
    dispatch(adminActions.updateCertification(formData.id, data));
    console.log(`formData on submit: ${JSON.stringify(formData)}`);
  };

  const setServiceOptionAndType = useCallback(() => {
    if (
      (certificationsData?.contractTimePeriod &&
        certificationsData?.vesselName) ||
      certificationsData?.ballastVoyageDescription
    ) {
      setServiceOption("Shipping");
      setServiceOptionType(
        certificationsData?.ballastVoyageDescription ? "Voyage" : "Time"
      );
    } else if (
      certificationsData?.airCraftType ||
      (certificationsData?.airCraftType &&
        certificationsData?.contractTimePeriod)
    ) {
      setServiceOption("Aviation");
      setServiceOptionType(
        certificationsData?.airCraftType &&
          certificationsData?.contractTimePeriod
          ? "TimeFlight"
          : "Flight"
      );
    } else {
      setServiceOption("Other");
      setServiceOptionType("");
    }
  }, [
    certificationsData?.contractTimePeriod,
    certificationsData?.vesselName,
    certificationsData?.ballastVoyageDescription,
    certificationsData?.airCraftType,
  ]);

  useEffect(() => {
    setServiceOptionAndType();
  }, [setServiceOptionAndType]);

  const stepToDisplay =
    certificationsData.certificationType === 3 ? (
      <ServiceFirstStep
        formData={certificationsData}
        setFormData={setFormData}
        register={register}
        setValue={setValue}
        formTyped={serviceOptionType}
        serviceTyped={serviceOption}
        errors={errors}
        errorCount={errorCount}
        unregister={unregister}
        onChangeFormType={onChangeFormType}
        onChangeServiceType={onChangeServiceType}
        reset={reset}
        isAdmin={true}
      />
    ) : (
      <FirstStepAdmin
        formData={certificationsData}
        setFormData={setFormData}
        register={register}
        setValue={setValue}
        errors={errors}
        errorCount={errorCount}
        unregister={unregister}
      />
    );

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-between">
          <span className="text-coc-blue font-semibold text-center text-lg">
            COC-{certificationsData?.certificationCode}
          </span>
          <span className="text-coc-blue font-semibold text-center text-lg">
            Type:{" "}
            {getCertificationTypeStringValue(
              certificationsData?.certificationType
            )}
          </span>
          {certificationsData?.certificationType === 3 && (
            <span className="text-coc-blue font-semibold text-center text-lg">
              Service Type: {serviceOption} - {serviceOptionType}
            </span>
          )}
        </div>

        {stepToDisplay}
        <SubmitButton
          text="Update"
          className="bg-[#3BB34B] mt-4 text-white w-full rounded-xs py-3 hover:bg-[#329940]"
          onclick={() => setErrorCount(errorCount + 1)}
        />
      </form>
    </>
  );
}
